export class GalleryModel {
  async upload(_elem, _idcod, _isNew, _images) {
    return await new Promise((resolve, reject) => {
      let images = _images || [];
      APICRUD.Image.Upload(_elem, null)
        .then(response => {
          // loading.Hide();
          if (response.message == 'OK') {
            if (_isNew) {
              images.push(response.idcod);
            } else {
              for (let i = 0; i < images.length; i++) {
                if (images[i] == _idcod) {
                  images[i] = response.idcod;
                  break;
                }
              }
            }
            resolve({
              images: images,
              idcod: response.idcod
            })
          }
        })
        .catch(error => {
          reject(error)
          console.error(error);
        });
    });
  }
}
